// THIS FILE IS AUTO-GENERATED — DO NOT EDIT
// Generated by: scripts/build-navigation.ts
// Source fragments: 52

import type { SidebarNavigationStructure } from "@/components/pages/docs/navigation/navigation";
export type DocumentationPagePath =
  | "dash0"
  | "dash0/ai/agent0/automations"
  | "dash0/ai/agent0/automations/concepts"
  | "dash0/ai/agent0/automations/control-sharing-and-access"
  | "dash0/ai/agent0/automations/create"
  | "dash0/ai/agent0/automations/create/configure-general-settings"
  | "dash0/ai/agent0/automations/create/configure-notifications"
  | "dash0/ai/agent0/automations/create/configure-triggers"
  | "dash0/ai/agent0/automations/create/set-guardrails"
  | "dash0/ai/agent0/automations/create/write-prompts"
  | "dash0/ai/agent0/automations/templates"
  | "dash0/ai/agent0/automations/troubleshooting"
  | "dash0/ai/agent0/automations/troubleshooting/guardrail-failure"
  | "dash0/ai/agent0/automations/troubleshooting/integrations"
  | "dash0/ai/agent0/automations/troubleshooting/not-triggering"
  | "dash0/ai/agent0/automations/troubleshooting/tool-calls"
  | "dash0/ai/agent0/automations/troubleshooting/variables"
  | "dash0/ai/agent0/chat"
  | "dash0/ai/agent0/chat/approve-write-actions"
  | "dash0/ai/agent0/chat/explore"
  | "dash0/ai/agent0/chat/explore/integrated-experience"
  | "dash0/ai/agent0/chat/explore/investigation-analysis"
  | "dash0/ai/agent0/chat/explore/live-insights"
  | "dash0/ai/agent0/chat/explore/parallel-threads"
  | "dash0/ai/agent0/chat/integrate"
  | "dash0/ai/agent0/chat/integrate/bash"
  | "dash0/ai/agent0/chat/integrate/setup-scripts"
  | "dash0/ai/agent0/chat/integrate/sql"
  | "dash0/ai/agent0/chat/troubleshooting"
  | "dash0/ai/agent0/chat/troubleshooting/agent0-behavior"
  | "dash0/ai/agent0/chat/troubleshooting/broken-assets"
  | "dash0/ai/agent0/chat/troubleshooting/investigation-cost"
  | "dash0/ai/agent0/chat/troubleshooting/live-insights"
  | "dash0/ai/agent0/chat/troubleshooting/tool-call-status"
  | "dash0/ai/agent0/memory"
  | "dash0/ai/agent0/overview"
  | "dash0/ai/agent0/overview/integrate-with-agent0"
  | "dash0/ai/agent0/overview/integrate-with-agent0/generic-mcp/mcp"
  | "dash0/ai/agent0/overview/integrate-with-agent0/generic-mcp/setup"
  | "dash0/ai/agent0/overview/integrate-with-agent0/github/github"
  | "dash0/ai/agent0/overview/integrate-with-agent0/github/setup"
  | "dash0/ai/agent0/overview/integrate-with-agent0/gitlab/gitlab"
  | "dash0/ai/agent0/overview/integrate-with-agent0/gitlab/setup"
  | "dash0/ai/agent0/overview/integrate-with-agent0/linear/linear"
  | "dash0/ai/agent0/overview/integrate-with-agent0/linear/linear-agent"
  | "dash0/ai/agent0/overview/integrate-with-agent0/linear/setup"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/mention"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/setup"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-best-practices"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-examples"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-tools"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-triggers"
  | "dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-troubleshooting"
  | "dash0/ai/agent0/overview/key-concepts"
  | "dash0/ai/agent0/overview/model-selection"
  | "dash0/ai/agent0/overview/use-agent0"
  | "dash0/ai/agent0/overview/use-agent0/alerts"
  | "dash0/ai/agent0/overview/use-agent0/dashboards"
  | "dash0/ai/agent0/overview/use-agent0/delegate-to-agent0"
  | "dash0/ai/agent0/overview/use-agent0/iac"
  | "dash0/ai/agent0/overview/use-agent0/pull-requests"
  | "dash0/ai/agent0/overview/use-agent0/query-telemetry-via-mcp"
  | "dash0/ai/agent0/overview/use-agent0/use-automations-and-integrations"
  | "dash0/ai/agent0/skills"
  | "dash0/ai/agent0/skills/control-sharing-and-access"
  | "dash0/ai/agent0/skills/import-from-git"
  | "dash0/ai/mcp"
  | "dash0/ai/observability/evals"
  | "dash0/ai/observability/evals/analyze-eval-results"
  | "dash0/ai/observability/evals/create-an-eval"
  | "dash0/ai/observability/evals/eval-result-records"
  | "dash0/ai/observability/evals/eval-templates"
  | "dash0/ai/observability/evals/key-concepts"
  | "dash0/ai/observability/evals/manage-evals"
  | "dash0/ai/observability/evals/write-eval-prompts"
  | "dash0/cost-control/about-spam-filters-as-code"
  | "dash0/cost-control/export-spam-filters"
  | "dash0/cost-control/forecast"
  | "dash0/cost-control/http-rate-limits"
  | "dash0/cost-control/install-forecast"
  | "dash0/cost-control/manage-spam-filters-as-code"
  | "dash0/cost-control/monthly-budget"
  | "dash0/cost-control/overview"
  | "dash0/cost-control/quotas-and-limits"
  | "dash0/cost-control/spam-filters"
  | "dash0/darkplane/insights"
  | "dash0/darkplane/insights/analyze-tools-skills"
  | "dash0/darkplane/insights/data-privacy"
  | "dash0/darkplane/insights/derived-metrics"
  | "dash0/darkplane/insights/explore-sessions"
  | "dash0/darkplane/insights/key-concepts"
  | "dash0/darkplane/insights/measure-productivity"
  | "dash0/darkplane/insights/overview"
  | "dash0/darkplane/insights/setup"
  | "dash0/darkplane/insights/span-attributes"
  | "dash0/darkplane/insights/track-adoption"
  | "dash0/darkplane/insights/track-cost"
  | "dash0/darkplane/insights/troubleshooting"
  | "dash0/darkplane/overview"
  | "dash0/dashboards/about-dashboards"
  | "dash0/dashboards/about-dashboards-as-code"
  | "dash0/dashboards/add-annotations"
  | "dash0/dashboards/add-panels"
  | "dash0/dashboards/add-variables"
  | "dash0/dashboards/add-variables/use-filter-variables"
  | "dash0/dashboards/add-variables/use-list-variables"
  | "dash0/dashboards/add-variables/use-text-variables"
  | "dash0/dashboards/annotations"
  | "dash0/dashboards/bind-variables-to-queries"
  | "dash0/dashboards/build-queries"
  | "dash0/dashboards/configure-panels"
  | "dash0/dashboards/control-sharing-and-access"
  | "dash0/dashboards/create-dashboards"
  | "dash0/dashboards/create-dashboards/create-dashboards-from-scratch"
  | "dash0/dashboards/create-dashboards/generate-dashboards-with-agent0"
  | "dash0/dashboards/drill-down-from-charts"
  | "dash0/dashboards/export-dashboards"
  | "dash0/dashboards/import-dashboards"
  | "dash0/dashboards/manage-dashboards-as-code"
  | "dash0/dashboards/manage-existing-dashboards"
  | "dash0/dashboards/reference-chart-types"
  | "dash0/dashboards/reference-dashboard-source-format"
  | "dash0/dashboards/reference-drilldown-explore-vs-triage"
  | "dash0/dashboards/reference-drilldown-filter-translation"
  | "dash0/dashboards/types/Dash0HeatmapChart"
  | "dash0/dashboards/types/Dash0TreeMapChart"
  | "dash0/dashboards/types/DependencyMap"
  | "dash0/dashboards/types/GaugeChart"
  | "dash0/dashboards/types/GeoMap"
  | "dash0/dashboards/types/HierarchyMap"
  | "dash0/dashboards/types/IssuesTimeline"
  | "dash0/dashboards/types/LogTable"
  | "dash0/dashboards/types/Markdown"
  | "dash0/dashboards/types/PieChart"
  | "dash0/dashboards/types/StatChart"
  | "dash0/dashboards/types/TimeSeriesChart"
  | "dash0/dashboards/types/TimeSeriesTable"
  | "dash0/get-started"
  | "dash0/get-started/use-ai"
  | "dash0/infrastructure/aws/about-aws"
  | "dash0/infrastructure/aws/aws-lambda/analyze-cold-starts"
  | "dash0/infrastructure/aws/aws-lambda/debug-timeouts-and-errors"
  | "dash0/infrastructure/aws/aws-lambda/overview"
  | "dash0/infrastructure/aws/aws-lambda/setup"
  | "dash0/infrastructure/aws/aws-lambda/trace-lambda-functions"
  | "dash0/infrastructure/aws/cloudwatch-metrics/collect-cloudwatch-metrics"
  | "dash0/infrastructure/aws/cloudwatch-metrics/filter-metrics-by-resource-tags"
  | "dash0/infrastructure/aws/cloudwatch-metrics/scraping-vs-metric-streams"
  | "dash0/infrastructure/aws/cloudwatch-metrics/use-resource-tags"
  | "dash0/infrastructure/aws/setup"
  | "dash0/infrastructure/google-cloud/about-google-cloud"
  | "dash0/infrastructure/google-cloud/cloud-run"
  | "dash0/infrastructure/google-cloud/cloud-run-jobs"
  | "dash0/infrastructure/google-cloud/cloud-sql"
  | "dash0/infrastructure/google-cloud/cloud-storage"
  | "dash0/infrastructure/google-cloud/pubsub"
  | "dash0/infrastructure/google-cloud/setup"
  | "dash0/miscellaneous/faq"
  | "dash0/miscellaneous/glossary/access-control"
  | "dash0/miscellaneous/glossary/adaptive-sampling"
  | "dash0/miscellaneous/glossary/auth-tokens"
  | "dash0/miscellaneous/glossary/command-menu"
  | "dash0/miscellaneous/glossary/dash0-api"
  | "dash0/miscellaneous/glossary/datasets"
  | "dash0/miscellaneous/glossary/deeplink-urls"
  | "dash0/miscellaneous/glossary/derived-attributes"
  | "dash0/miscellaneous/glossary/endpoints"
  | "dash0/miscellaneous/glossary/evals"
  | "dash0/miscellaneous/glossary/filtering"
  | "dash0/miscellaneous/glossary/infrastructure-as-code"
  | "dash0/miscellaneous/glossary/operation-names"
  | "dash0/miscellaneous/glossary/organizations"
  | "dash0/miscellaneous/glossary/overview"
  | "dash0/miscellaneous/glossary/red-metrics"
  | "dash0/miscellaneous/glossary/resource-equality"
  | "dash0/miscellaneous/glossary/resource-fragmentation"
  | "dash0/miscellaneous/glossary/semantic-convention-upgrades"
  | "dash0/miscellaneous/glossary/semantic-conventions"
  | "dash0/miscellaneous/glossary/synthetic-metrics"
  | "dash0/miscellaneous/glossary/teams"
  | "dash0/miscellaneous/glossary/time-picker"
  | "dash0/miscellaneous/glossary/views"
  | "dash0/miscellaneous/manage-as-code/about-managing-as-code"
  | "dash0/miscellaneous/manage-as-code/manage-cicd-observability-as-code"
  | "dash0/miscellaneous/manage-as-code/manage-teams-as-code"
  | "dash0/miscellaneous/settings"
  | "dash0/miscellaneous/settings/ai"
  | "dash0/miscellaneous/settings/audit-logs"
  | "dash0/miscellaneous/settings/billing"
  | "dash0/miscellaneous/settings/general"
  | "dash0/miscellaneous/settings/integrations"
  | "dash0/miscellaneous/settings/oauth2"
  | "dash0/miscellaneous/settings/user-authentication"
  | "dash0/miscellaneous/tooling/dash0-cli/about"
  | "dash0/miscellaneous/tooling/dash0-cli/brew-tap-migration-2026-06"
  | "dash0/miscellaneous/tooling/dash0-cli/commands"
  | "dash0/miscellaneous/tooling/dash0-cli/github-actions/about"
  | "dash0/miscellaneous/tooling/dash0-cli/github-actions/send-log-event"
  | "dash0/miscellaneous/tooling/dash0-cli/github-actions/setup"
  | "dash0/miscellaneous/tooling/dash0-cli/github-actions/sync-assets"
  | "dash0/miscellaneous/tooling/dash0-cli/installation"
  | "dash0/miscellaneous/tooling/dash0-cli/quickstart"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/about"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/actions/deployment-event"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/actions/log-event"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/configuration"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/guides/aws-cloudformation-integration"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/guides/import-existing-assets"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/quickstart"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/auth-token"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/aws-metric-scrape-config"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/check-rule"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/dashboard"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/dataset"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/notification-channel"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/recording-rule"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/sampling-rule"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/slo"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/spam-filter"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/synthetic-check"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/team"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/time-series-aggregation"
  | "dash0/miscellaneous/tooling/terraform-provider-dash0/resources/view"
  | "dash0/miscellaneous/tooling/web-sdk/api"
  | "dash0/miscellaneous/tooling/web-sdk/configuration"
  | "dash0/miscellaneous/tooling/web-sdk/installation"
  | "dash0/miscellaneous/tooling/web-sdk/overview"
  | "dash0/miscellaneous/tooling/web-sdk/setup"
  | "dash0/miscellaneous/troubleshooting"
  | "dash0/miscellaneous/views/about-views"
  | "dash0/miscellaneous/views/export-views"
  | "dash0/miscellaneous/views/manage-views-as-code"
  | "dash0/monitoring/alerting/about-check-rules-as-code"
  | "dash0/monitoring/alerting/about-notifications"
  | "dash0/monitoring/alerting/alert-on-slos"
  | "dash0/monitoring/alerting/alerting"
  | "dash0/monitoring/alerting/alerting-model"
  | "dash0/monitoring/alerting/check-rule-limits"
  | "dash0/monitoring/alerting/configure-meta-check-rules"
  | "dash0/monitoring/alerting/create-check-rules"
  | "dash0/monitoring/alerting/create-check-rules-from-charts"
  | "dash0/monitoring/alerting/create-check-rules-from-scratch"
  | "dash0/monitoring/alerting/create-contextual-alert-messages"
  | "dash0/monitoring/alerting/create-slos"
  | "dash0/monitoring/alerting/export-check-rules"
  | "dash0/monitoring/alerting/export-notification-channels"
  | "dash0/monitoring/alerting/generate-alert-checks-with-agent0"
  | "dash0/monitoring/alerting/generate-check-rules-with-agent0"
  | "dash0/monitoring/alerting/investigate-failed-checks"
  | "dash0/monitoring/alerting/manage-check-rules-as-code"
  | "dash0/monitoring/alerting/manage-notification-channels-as-code"
  | "dash0/monitoring/alerting/manage-slos-as-code"
  | "dash0/monitoring/alerting/monitor-notification-channel-delivery"
  | "dash0/monitoring/alerting/route-alert-check-notifications"
  | "dash0/monitoring/alerting/send-alert-check-notifications"
  | "dash0/monitoring/alerting/silence-failed-checks"
  | "dash0/monitoring/alerting/slos"
  | "dash0/monitoring/alerting/slos-api"
  | "dash0/monitoring/alerting/troubleshooting-check-rules"
  | "dash0/monitoring/alerting/use-failed-check-details-view"
  | "dash0/monitoring/alerting/use-failed-check-telemetry-view"
  | "dash0/monitoring/alerting/use-failed-checks-view"
  | "dash0/monitoring/alerting/view-slos"
  | "dash0/monitoring/kubernetes/about-kubernetes"
  | "dash0/monitoring/kubernetes/dash0-operator/advanced-configuration"
  | "dash0/monitoring/kubernetes/dash0-operator/agent0-integration"
  | "dash0/monitoring/kubernetes/dash0-operator/auto-instrumentation"
  | "dash0/monitoring/kubernetes/dash0-operator/configuration"
  | "dash0/monitoring/kubernetes/dash0-operator/installation"
  | "dash0/monitoring/kubernetes/dash0-operator/managing-dash0-resources"
  | "dash0/monitoring/kubernetes/dash0-operator/metrics-and-scraping"
  | "dash0/monitoring/kubernetes/dash0-operator/overview"
  | "dash0/monitoring/kubernetes/dash0-operator/platform-specific"
  | "dash0/monitoring/kubernetes/dash0-operator/profiling"
  | "dash0/monitoring/kubernetes/dash0-operator/signal-control-edge"
  | "dash0/monitoring/kubernetes/dash0-operator/synthetics-worker"
  | "dash0/monitoring/kubernetes/dash0-operator/troubleshooting"
  | "dash0/monitoring/kubernetes/dash0-operator/upgrading"
  | "dash0/monitoring/kubernetes/kubernetes-metrics"
  | "dash0/monitoring/resources/about-resources"
  | "dash0/monitoring/resources/explore-resources"
  | "dash0/monitoring/resources/platforms/aws"
  | "dash0/monitoring/resources/platforms/containers-and-hosts"
  | "dash0/monitoring/resources/platforms/gcp"
  | "dash0/monitoring/resources/platforms/kubernetes"
  | "dash0/monitoring/resources/platforms/other-platforms"
  | "dash0/monitoring/resources/resource-equality"
  | "dash0/monitoring/resources/resource-equality-rules"
  | "dash0/monitoring/resources/resource-storage-query-behavior"
  | "dash0/monitoring/services/about-services"
  | "dash0/monitoring/services/built-in-metrics"
  | "dash0/monitoring/services/use-service-catalog"
  | "dash0/monitoring/services/use-service-map"
  | "dash0/monitoring/synthetics/about-synthetic-checks-as-code"
  | "dash0/monitoring/synthetics/create-synthetic-checks"
  | "dash0/monitoring/synthetics/define-request-configuration"
  | "dash0/monitoring/synthetics/define-schedules-retries"
  | "dash0/monitoring/synthetics/define-success-criteria"
  | "dash0/monitoring/synthetics/explore-run-details"
  | "dash0/monitoring/synthetics/explore-synthetic-checks"
  | "dash0/monitoring/synthetics/export-synthetic-checks"
  | "dash0/monitoring/synthetics/manage-synthetic-checks-as-code"
  | "dash0/monitoring/synthetics/private-locations"
  | "dash0/monitoring/synthetics/synthetic-monitoring"
  | "dash0/monitoring/synthetics/understand-synthetic-metrics"
  | "dash0/monitoring/websites/analyze-web-vitals"
  | "dash0/monitoring/websites/common-website-monitoring-issues"
  | "dash0/monitoring/websites/correlate-sessions-backend-traces"
  | "dash0/monitoring/websites/data-privacy"
  | "dash0/monitoring/websites/filter-sessions-data"
  | "dash0/monitoring/websites/getting-started-website-monitoring"
  | "dash0/monitoring/websites/investigate-sessions"
  | "dash0/monitoring/websites/monitor-website-overview"
  | "dash0/monitoring/websites/proxying-the-ingestion-endpoint"
  | "dash0/monitoring/websites/resolve-stack-traces-with-source-maps"
  | "dash0/monitoring/websites/set-up-source-map-integration"
  | "dash0/monitoring/websites/understand-sessions"
  | "dash0/monitoring/websites/understand-web-vitals"
  | "dash0/monitoring/websites/view-event-details"
  | "dash0/monitoring/websites/view-full-session"
  | "dash0/monitoring/websites/view-full-trace"
  | "dash0/monitoring/websites/view-session-details"
  | "dash0/monitoring/websites/watch-session-replay"
  | "dash0/monitoring/websites/website-monitoring"
  | "dash0/opentelemetry/distributions/python/auto-instrumentation"
  | "dash0/opentelemetry/distributions/python/configuration"
  | "dash0/opentelemetry/distributions/python/exporters"
  | "dash0/opentelemetry/distributions/python/getting-started"
  | "dash0/opentelemetry/distributions/python/kubernetes-injection"
  | "dash0/opentelemetry/distributions/python/overview"
  | "dash0/opentelemetry/distributions/python/resource-detection"
  | "dash0/opentelemetry/distributions/ruby/auto-instrumentation"
  | "dash0/opentelemetry/distributions/ruby/configuration"
  | "dash0/opentelemetry/distributions/ruby/getting-started"
  | "dash0/opentelemetry/distributions/ruby/kubernetes-injection"
  | "dash0/opentelemetry/distributions/ruby/overview"
  | "dash0/opentelemetry/distributions/ruby/resource-detection"
  | "dash0/opentelemetry/semconvs/attributes/log"
  | "dash0/opentelemetry/semconvs/attributes/metric"
  | "dash0/opentelemetry/semconvs/attributes/overview"
  | "dash0/opentelemetry/semconvs/attributes/span"
  | "dash0/opentelemetry/semconvs/attributes/web-event"
  | "dash0/opentelemetry/semconvs/events/deployment"
  | "dash0/opentelemetry/semconvs/events/overview"
  | "dash0/opentelemetry/semconvs/metrics/automations"
  | "dash0/opentelemetry/semconvs/metrics/check"
  | "dash0/opentelemetry/semconvs/metrics/gen-ai"
  | "dash0/opentelemetry/semconvs/metrics/issue"
  | "dash0/opentelemetry/semconvs/metrics/logs"
  | "dash0/opentelemetry/semconvs/metrics/metrics"
  | "dash0/opentelemetry/semconvs/metrics/operator"
  | "dash0/opentelemetry/semconvs/metrics/overview"
  | "dash0/opentelemetry/semconvs/metrics/resources"
  | "dash0/opentelemetry/semconvs/metrics/slo"
  | "dash0/opentelemetry/semconvs/metrics/spam-filters"
  | "dash0/opentelemetry/semconvs/metrics/span"
  | "dash0/opentelemetry/semconvs/metrics/spans"
  | "dash0/opentelemetry/semconvs/metrics/synthetic-check"
  | "dash0/opentelemetry/semconvs/metrics/web"
  | "dash0/opentelemetry/semconvs/overview"
  | "dash0/telemetry/data-privacy/redact-cardholder-data"
  | "dash0/telemetry/logging/about-logging"
  | "dash0/telemetry/logging/about-sending-logs"
  | "dash0/telemetry/logging/configure-pino"
  | "dash0/telemetry/logging/groups"
  | "dash0/telemetry/logging/json-log-processing"
  | "dash0/telemetry/logging/k8s-object-log-processing"
  | "dash0/telemetry/logging/log-ai-processing"
  | "dash0/telemetry/logging/log-severities"
  | "dash0/telemetry/logging/log-sidebar"
  | "dash0/telemetry/logging/log-table"
  | "dash0/telemetry/logging/nginx-log-processing"
  | "dash0/telemetry/logging/optimize-log-query-performance"
  | "dash0/telemetry/logging/patterns"
  | "dash0/telemetry/logging/related-logs"
  | "dash0/telemetry/logging/send-vercel-logs"
  | "dash0/telemetry/logging/triage"
  | "dash0/telemetry/logging/understand-log-events"
  | "dash0/telemetry/logging/use-ai-in-logs"
  | "dash0/telemetry/logging/use-ai-in-logs/derived-attributes"
  | "dash0/telemetry/logging/use-ai-in-logs/filter-attributes"
  | "dash0/telemetry/logging/use-ai-in-logs/group-attributes"
  | "dash0/telemetry/logging/use-ai-in-logs/pattern-hover"
  | "dash0/telemetry/logging/use-ai-in-logs/severity-indicator"
  | "dash0/telemetry/logging/use-ai-in-logs/triage-attributes"
  | "dash0/telemetry/logging/views"
  | "dash0/telemetry/metrics/about-metrics"
  | "dash0/telemetry/metrics/browse-and-filter-metrics"
  | "dash0/telemetry/metrics/common-metric-query-issues"
  | "dash0/telemetry/metrics/identify-high-cardinality-metrics"
  | "dash0/telemetry/metrics/inspect-metric-details"
  | "dash0/telemetry/metrics/optimize-promql-query-performance"
  | "dash0/telemetry/metrics/query-metrics"
  | "dash0/telemetry/metrics/recording-rule-limits"
  | "dash0/telemetry/metrics/understand-otel-metric-names"
  | "dash0/telemetry/metrics/understand-synthetic-metrics"
  | "dash0/telemetry/metrics/write-effective-promql-queries"
  | "dash0/telemetry/query-data/query-builder/about-query-builder"
  | "dash0/telemetry/query-data/query-builder/analyze-all-metrics"
  | "dash0/telemetry/query-data/query-builder/analyze-logs"
  | "dash0/telemetry/query-data/query-builder/analyze-service-metrics"
  | "dash0/telemetry/query-data/query-builder/analyze-tracing-metrics"
  | "dash0/telemetry/query-data/query-builder/analyze-web-events"
  | "dash0/telemetry/query-data/query-builder/references/examples-log-queries"
  | "dash0/telemetry/query-data/query-builder/references/examples-service-queries"
  | "dash0/telemetry/query-data/query-builder/references/examples-tracing-queries"
  | "dash0/telemetry/query-data/query-builder/references/examples-web-event-queries"
  | "dash0/telemetry/query-data/query-builder/write-promql-queries"
  | "dash0/telemetry/query-data/sql/about-sql"
  | "dash0/telemetry/query-data/sql/explore-your-schema"
  | "dash0/telemetry/query-data/sql/manage-saved-queries"
  | "dash0/telemetry/query-data/sql/troubleshoot-sql-queries"
  | "dash0/telemetry/query-data/sql/use-query-templates"
  | "dash0/telemetry/query-data/sql/use-supported-functions"
  | "dash0/telemetry/query-data/sql/write-sql-queries"
  | "dash0/telemetry/signal-control/about-signal-control"
  | "dash0/telemetry/signal-control/aggregate-time-series"
  | "dash0/telemetry/signal-control/convert-signals-to-metrics"
  | "dash0/telemetry/signal-control/edge/about-signalcontrol-edge"
  | "dash0/telemetry/signal-control/edge/edge-proxy"
  | "dash0/telemetry/signal-control/edge/setup-without-kubernetes"
  | "dash0/telemetry/signal-control/filter-out-spam"
  | "dash0/telemetry/signal-control/sample-traces"
  | "dash0/telemetry/tracing"
  | "dash0/telemetry/tracing/about-gen-ai-spans"
  | "dash0/telemetry/tracing/about-tracing"
  | "dash0/telemetry/tracing/groups"
  | "dash0/telemetry/tracing/outliers-map"
  | "dash0/telemetry/tracing/red"
  | "dash0/telemetry/tracing/semantic-coloring"
  | "dash0/telemetry/tracing/span-events"
  | "dash0/telemetry/tracing/span-events-to-logs"
  | "dash0/telemetry/tracing/span-sidebar"
  | "dash0/telemetry/tracing/span-table"
  | "dash0/telemetry/tracing/triage"
  | "dash0/telemetry/tracing/view"
  | "dash0/telemetry/tracing/view-explorer"
  | "dash0/telemetry/web-events"
  | "dash0/telemetry/web-events/about-web-events"
  | "dash0/telemetry/web-events/analyze-page-views"
  | "dash0/telemetry/web-events/explore-all-web-events"
  | "dash0/telemetry/web-events/filter-and-group-web-events"
  | "dash0/telemetry/web-events/monitor-javascript-errors"
  | "dash0/telemetry/web-events/track-http-requests"
  | "dash0/telemetry/web-events/understand-web-event-types"
  | "dash0/telemetry/web-events/use-custom-events"
  | "otelbin"
  | "otelbin/introduction-to-otelbin"
  | "otelbin/sharing-otel-collector-configurations"
  | "otelbin/validating-otel-collector-config"
  | "otelbin/visualizing-otel-collector-config";

export const navigationBySection: Record<string, SidebarNavigationStructure> = {
  "otelbin": [
    {
      "title": "Introduction to OTelBin",
      "href": "/docs/otelbin/introduction-to-otelbin",
      "lastUpdated": "2026-10-11T12:00:00.000Z"
    },
    {
      "title": "Visualizing Configurations",
      "href": "/docs/otelbin/visualizing-otel-collector-config",
      "lastUpdated": "2026-07-08T08:00:00.000Z"
    },
    {
      "title": "Validating Configurations",
      "href": "/docs/otelbin/validating-otel-collector-config",
      "lastUpdated": "2026-07-08T08:00:00.000Z"
    },
    {
      "title": "Sharing Configurations",
      "href": "/docs/otelbin/sharing-otel-collector-configurations",
      "lastUpdated": "2026-07-08T08:00:00.000Z"
    }
  ],
  "dash0": [
    {
      "title": "Get Started",
      "href": "/docs/dash0/get-started",
      "lastUpdated": "2026-10-11T12:00:00.000Z"
    },
    {
      "title": "Use AI in Dash0",
      "href": "/docs/dash0/get-started/use-ai",
      "lastUpdated": "2026-10-28T10:00:00.000Z"
    },
    {
      "title": "Dashboards",
      "children": [
        {
          "title": "About Dashboards",
          "href": "/docs/dash0/dashboards/about-dashboards",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Create Dashboards",
          "children": [
            {
              "title": "About Creating Dashboards",
              "href": "/docs/dash0/dashboards/create-dashboards",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Generate Dashboards with Agent0",
              "href": "/docs/dash0/dashboards/create-dashboards/generate-dashboards-with-agent0",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Create Dashboards from Scratch",
              "href": "/docs/dash0/dashboards/create-dashboards/create-dashboards-from-scratch",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            }
          ]
        },
        {
          "title": "Work with Dashboards",
          "children": [
            {
              "title": "Manage Dashboards",
              "href": "/docs/dash0/dashboards/manage-existing-dashboards",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Add Variables",
              "children": [
                {
                  "title": "About Adding Variables",
                  "href": "/docs/dash0/dashboards/add-variables",
                  "lastUpdated": "2026-10-11T12:00:00.000Z"
                },
                {
                  "title": "Use Filter Variables",
                  "href": "/docs/dash0/dashboards/add-variables/use-filter-variables",
                  "lastUpdated": "2026-07-28T10:00:00.000Z"
                },
                {
                  "title": "Use List Variables",
                  "href": "/docs/dash0/dashboards/add-variables/use-list-variables",
                  "lastUpdated": "2026-08-25T13:00:00.000Z"
                },
                {
                  "title": "Use Text Variables",
                  "href": "/docs/dash0/dashboards/add-variables/use-text-variables",
                  "lastUpdated": "2026-07-28T10:00:00.000Z"
                }
              ]
            },
            {
              "title": "Drill Down from Charts",
              "href": "/docs/dash0/dashboards/drill-down-from-charts",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Control Dashboard Sharing and Access",
              "href": "/docs/dash0/dashboards/control-sharing-and-access",
              "lastUpdated": "2026-04-20T05:00:00.000Z"
            }
          ]
        },
        {
          "title": "Work with Panels",
          "children": [
            {
              "title": "Add Panels",
              "href": "/docs/dash0/dashboards/add-panels",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Configure Panels",
              "href": "/docs/dash0/dashboards/configure-panels",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Build Queries",
              "href": "/docs/dash0/dashboards/build-queries",
              "lastUpdated": "2026-07-28T10:00:00.000Z"
            },
            {
              "title": "Bind Variables to Queries",
              "href": "/docs/dash0/dashboards/bind-variables-to-queries",
              "lastUpdated": "2026-08-25T11:00:00.000Z"
            },
            {
              "title": "Add Annotations",
              "href": "/docs/dash0/dashboards/add-annotations",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            }
          ]
        },
        {
          "title": "Manage as Code",
          "children": [
            {
              "title": "About Managing as Code",
              "href": "/docs/dash0/dashboards/about-dashboards-as-code",
              "lastUpdated": "2026-07-19T09:00:00.000Z"
            },
            {
              "title": "Export Dashboards",
              "href": "/docs/dash0/dashboards/export-dashboards",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Import Dashboards",
              "href": "/docs/dash0/dashboards/import-dashboards",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Manage Dashboards as Code",
              "href": "/docs/dash0/dashboards/manage-dashboards-as-code",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            }
          ]
        },
        {
          "title": "References",
          "children": [
            {
              "title": "About Chart Types",
              "href": "/docs/dash0/dashboards/reference-chart-types",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Chart Type Format",
              "href": "/docs/dash0/dashboards/reference-dashboard-source-format",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Drilldown: Filter Translation",
              "href": "/docs/dash0/dashboards/reference-drilldown-filter-translation",
              "lastUpdated": "2026-05-06T09:00:00.000Z"
            },
            {
              "title": "Drilldown: Explore vs. Triage",
              "href": "/docs/dash0/dashboards/reference-drilldown-explore-vs-triage",
              "lastUpdated": "2026-05-06T09:00:00.000Z"
            },
            {
              "title": "Dash0HeatmapChart",
              "href": "/docs/dash0/dashboards/types/Dash0HeatmapChart",
              "lastUpdated": "2026-04-20T05:00:00.000Z"
            },
            {
              "title": "Dash0TreeMapChart",
              "href": "/docs/dash0/dashboards/types/Dash0TreeMapChart",
              "lastUpdated": "2026-04-20T05:00:00.000Z"
            },
            {
              "title": "DependencyMap",
              "href": "/docs/dash0/dashboards/types/DependencyMap",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "GaugeChart",
              "href": "/docs/dash0/dashboards/types/GaugeChart",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "GeoMap",
              "href": "/docs/dash0/dashboards/types/GeoMap",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "HierarchyMap",
              "href": "/docs/dash0/dashboards/types/HierarchyMap",
              "lastUpdated": "2026-04-20T05:00:00.000Z"
            },
            {
              "title": "IssuesTimeline",
              "href": "/docs/dash0/dashboards/types/IssuesTimeline",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "LogTable",
              "href": "/docs/dash0/dashboards/types/LogTable",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Markdown",
              "href": "/docs/dash0/dashboards/types/Markdown",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "PieChart",
              "href": "/docs/dash0/dashboards/types/PieChart",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "StatChart",
              "href": "/docs/dash0/dashboards/types/StatChart",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "TimeSeriesChart",
              "href": "/docs/dash0/dashboards/types/TimeSeriesChart",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "TimeSeriesTable",
              "href": "/docs/dash0/dashboards/types/TimeSeriesTable",
              "lastUpdated": "2026-04-20T05:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Integration Hub",
      "href": "https://app.dash0.com/hub/integrations"
    },
    {
      "title": "Billing & Cost Control",
      "children": [
        {
          "title": "About Billing & Cost Control",
          "href": "/docs/dash0/cost-control/overview",
          "lastUpdated": "2026-10-22T10:15:35.000Z"
        },
        {
          "title": "Set Spam Filters",
          "href": "/docs/dash0/cost-control/spam-filters",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Manage as Code",
          "children": [
            {
              "title": "About Managing as Code",
              "href": "/docs/dash0/cost-control/about-spam-filters-as-code",
              "lastUpdated": "2026-07-19T09:00:00.000Z"
            },
            {
              "title": "Export Spam Filters",
              "href": "/docs/dash0/cost-control/export-spam-filters",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Manage Spam Filters as Code",
              "href": "/docs/dash0/cost-control/manage-spam-filters-as-code",
              "lastUpdated": "2026-08-09T18:00:00.000Z"
            }
          ]
        },
        {
          "title": "Set a Monthly Budget",
          "href": "/docs/dash0/cost-control/monthly-budget",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Forecast Your Spend",
          "href": "/docs/dash0/cost-control/forecast",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Install the Telemetry Dashboards",
          "href": "/docs/dash0/cost-control/install-forecast",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Understand Telemetry Ingestion Limits",
          "href": "/docs/dash0/cost-control/quotas-and-limits",
          "lastUpdated": "2026-10-28T09:00:00.000Z"
        },
        {
          "title": "Understand HTTP Rate Limits",
          "href": "/docs/dash0/cost-control/http-rate-limits",
          "lastUpdated": "2026-07-19T09:00:00.000Z"
        }
      ]
    },
    {
      "title": "Agent0"
    },
    {
      "title": "About Agent0",
      "children": [
        {
          "title": "Overview",
          "href": "/docs/dash0/ai/agent0/overview",
          "lastUpdated": "2026-10-29T15:00:00.000Z"
        },
        {
          "title": "Key Concepts",
          "href": "/docs/dash0/ai/agent0/overview/key-concepts",
          "lastUpdated": "2026-10-29T15:00:00.000Z"
        },
        {
          "title": "Model Selection",
          "href": "/docs/dash0/ai/agent0/overview/model-selection",
          "lastUpdated": "2026-10-22T10:15:35.000Z"
        },
        {
          "title": "Use Agent0",
          "children": [
            {
              "title": "About Using Agent0",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Create Dashboards",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/dashboards",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Create Check Rules",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/alerts",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Create Infrastructure as Code",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/iac",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Create Pull Requests",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/pull-requests",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Use Automations and Integrations",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/use-automations-and-integrations",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Query Telemetry via MCP",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/query-telemetry-via-mcp",
              "lastUpdated": "2026-10-27T10:00:00.000Z"
            },
            {
              "title": "Delegate to Agent0 via MCP",
              "href": "/docs/dash0/ai/agent0/overview/use-agent0/delegate-to-agent0",
              "lastUpdated": "2026-10-28T10:00:00.000Z"
            }
          ]
        },
        {
          "title": "Integrate with Agent0",
          "children": [
            {
              "title": "About Integrating with Agent0",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0",
              "lastUpdated": "2026-08-26T07:00:00.000Z"
            },
            {
              "title": "Integrate with GitHub",
              "children": [
                {
                  "title": "Set Up GitHub Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/github/setup",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Use GitHub in Chat and Automations",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/github/github",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                }
              ]
            },
            {
              "title": "Integrate with GitLab",
              "children": [
                {
                  "title": "Set Up GitLab Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/gitlab/setup",
                  "lastUpdated": "2026-08-26T07:00:00.000Z"
                },
                {
                  "title": "Use GitLab in Chat and Automations",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/gitlab/gitlab",
                  "lastUpdated": "2026-08-26T07:00:00.000Z"
                }
              ]
            },
            {
              "title": "Integrate with Linear",
              "children": [
                {
                  "title": "Set Up Linear Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/linear/setup",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Use Linear in Chat and Automations",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/linear/linear",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Use the Dash0 Linear Agent",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/linear/linear-agent",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                }
              ]
            },
            {
              "title": "Integrate with Slack",
              "children": [
                {
                  "title": "Ask Agent0 in a Slack Channel",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/mention",
                  "lastUpdated": "2026-09-09T15:00:00.000Z"
                },
                {
                  "title": "Set Up Slack Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/setup",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Configure Slack Triggers",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-triggers",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Use Slack Tools",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-tools",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Explore Slack Integration Examples",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-examples",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Best Practices",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-best-practices",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Troubleshoot Slack Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/slack-troubleshooting",
                  "lastUpdated": "2026-08-31T15:00:00.000Z"
                }
              ]
            },
            {
              "title": "Integrate with Generic MCPs",
              "children": [
                {
                  "title": "Set Up MCP Integration",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/generic-mcp/setup",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Use MCP in Chat and Automations",
                  "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/generic-mcp/mcp",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "title": "Chat",
      "children": [
        {
          "title": "About Chat",
          "href": "/docs/dash0/ai/agent0/chat",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Explore Chat",
          "children": [
            {
              "title": "About Exploring Chat",
              "href": "/docs/dash0/ai/agent0/chat/explore",
              "lastUpdated": "2026-09-24T13:22:05.000Z"
            },
            {
              "title": "Investigate & Analyze",
              "href": "/docs/dash0/ai/agent0/chat/explore/investigation-analysis",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Get Live Insights",
              "href": "/docs/dash0/ai/agent0/chat/explore/live-insights",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use the Integrated Experience",
              "href": "/docs/dash0/ai/agent0/chat/explore/integrated-experience",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Run Threads in Parallel",
              "href": "/docs/dash0/ai/agent0/chat/explore/parallel-threads",
              "lastUpdated": "2026-09-30T17:38:42.000Z"
            }
          ]
        },
        {
          "title": "Use External Tools",
          "children": [
            {
              "title": "About Using External Tools",
              "href": "/docs/dash0/ai/agent0/chat/integrate",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use Bash in Chat",
              "href": "/docs/dash0/ai/agent0/chat/integrate/bash",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use SQL in Chat",
              "href": "/docs/dash0/ai/agent0/chat/integrate/sql",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use a Setup Script in Chat",
              "href": "/docs/dash0/ai/agent0/chat/integrate/setup-scripts",
              "lastUpdated": "2026-10-20T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Approve Write Actions",
          "href": "/docs/dash0/ai/agent0/chat/approve-write-actions",
          "lastUpdated": "2026-08-13T08:00:00.000Z"
        },
        {
          "title": "Troubleshooting",
          "children": [
            {
              "title": "About Troubleshooting",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Tool Call Status",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting/tool-call-status",
              "lastUpdated": "2026-08-10T14:00:00.000Z"
            },
            {
              "title": "Agent0 Did Not Do What I Asked",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting/agent0-behavior",
              "lastUpdated": "2026-08-10T14:00:00.000Z"
            },
            {
              "title": "Investigation Cost More Than Expected",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting/investigation-cost",
              "lastUpdated": "2026-10-22T10:15:35.000Z"
            },
            {
              "title": "Dashboard or Alert Doesn't Work",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting/broken-assets",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Live Insights Not Showing Services",
              "href": "/docs/dash0/ai/agent0/chat/troubleshooting/live-insights",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Automations",
      "children": [
        {
          "title": "About Automations",
          "href": "/docs/dash0/ai/agent0/automations",
          "lastUpdated": "2026-09-29T11:00:00.000Z"
        },
        {
          "title": "Key Concepts",
          "href": "/docs/dash0/ai/agent0/automations/concepts",
          "lastUpdated": "2026-10-05T08:00:00.000Z"
        },
        {
          "title": "Create Automations",
          "children": [
            {
              "title": "About Creating Automations",
              "href": "/docs/dash0/ai/agent0/automations/create",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Configure General Settings",
              "href": "/docs/dash0/ai/agent0/automations/create/configure-general-settings",
              "lastUpdated": "2026-09-29T11:00:00.000Z"
            },
            {
              "title": "Configure Triggers",
              "href": "/docs/dash0/ai/agent0/automations/create/configure-triggers",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Write Prompts",
              "href": "/docs/dash0/ai/agent0/automations/create/write-prompts",
              "lastUpdated": "2026-09-09T09:00:00.000Z"
            },
            {
              "title": "Configure Notifications",
              "href": "/docs/dash0/ai/agent0/automations/create/configure-notifications",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Set Guardrails",
              "href": "/docs/dash0/ai/agent0/automations/create/set-guardrails",
              "lastUpdated": "2026-08-26T07:00:00.000Z"
            }
          ]
        },
        {
          "title": "Use Templates",
          "href": "/docs/dash0/ai/agent0/automations/templates",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Control Automation Sharing and Access",
          "href": "/docs/dash0/ai/agent0/automations/control-sharing-and-access",
          "lastUpdated": "2026-09-29T11:00:00.000Z"
        },
        {
          "title": "Troubleshooting",
          "children": [
            {
              "title": "About Troubleshooting",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting",
              "lastUpdated": "2026-07-24T09:00:00.000Z"
            },
            {
              "title": "Automation Doesn't Trigger",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting/not-triggering",
              "lastUpdated": "2026-08-26T07:00:00.000Z"
            },
            {
              "title": "Run Fails with Guardrail Failure",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting/guardrail-failure",
              "lastUpdated": "2026-07-24T09:00:00.000Z"
            },
            {
              "title": "Agent0 Doesn't Call Expected Tools",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting/tool-calls",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Variables Show as {{...}}",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting/variables",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Missing Integration Warnings",
              "href": "/docs/dash0/ai/agent0/automations/troubleshooting/integrations",
              "lastUpdated": "2026-08-26T07:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Skills",
      "children": [
        {
          "title": "About Skills",
          "href": "/docs/dash0/ai/agent0/skills",
          "lastUpdated": "2026-10-05T08:00:00.000Z"
        },
        {
          "title": "Import from a Git Repository",
          "href": "/docs/dash0/ai/agent0/skills/import-from-git",
          "lastUpdated": "2026-10-05T08:00:00.000Z"
        },
        {
          "title": "Control Skill Sharing and Access",
          "href": "/docs/dash0/ai/agent0/skills/control-sharing-and-access",
          "lastUpdated": "2026-10-05T08:00:00.000Z"
        }
      ]
    },
    {
      "title": "Memory",
      "children": [
        {
          "title": "About Memory",
          "href": "/docs/dash0/ai/agent0/memory",
          "lastUpdated": "2026-10-29T15:00:00.000Z"
        }
      ]
    },
    {
      "title": "Dash0 MCP Server",
      "children": [
        {
          "title": "About the Dash0 MCP Server",
          "href": "/docs/dash0/ai/mcp",
          "lastUpdated": "2026-10-28T13:00:00.000Z"
        }
      ]
    },
    {
      "title": "AI Observability"
    },
    {
      "title": "Evals",
      "children": [
        {
          "title": "About Evals",
          "href": "/docs/dash0/ai/observability/evals",
          "lastUpdated": "2026-11-05T11:00:00.000Z"
        },
        {
          "title": "Key Concepts",
          "href": "/docs/dash0/ai/observability/evals/key-concepts",
          "lastUpdated": "2026-11-05T11:00:00.000Z"
        },
        {
          "title": "Create an Eval",
          "href": "/docs/dash0/ai/observability/evals/create-an-eval",
          "lastUpdated": "2026-11-05T11:00:00.000Z"
        },
        {
          "title": "Eval Templates",
          "href": "/docs/dash0/ai/observability/evals/eval-templates",
          "lastUpdated": "2026-11-05T11:00:00.000Z"
        },
        {
          "title": "Write Eval Prompts",
          "href": "/docs/dash0/ai/observability/evals/write-eval-prompts",
          "lastUpdated": "2026-10-19T08:00:00.000Z"
        },
        {
          "title": "Analyze Eval Results",
          "href": "/docs/dash0/ai/observability/evals/analyze-eval-results",
          "lastUpdated": "2026-11-05T11:00:00.000Z"
        },
        {
          "title": "Manage Evals",
          "href": "/docs/dash0/ai/observability/evals/manage-evals",
          "lastUpdated": "2026-10-12T11:00:00.000Z"
        },
        {
          "title": "Eval Result Records",
          "href": "/docs/dash0/ai/observability/evals/eval-result-records",
          "lastUpdated": "2026-10-12T11:00:00.000Z"
        }
      ]
    },
    {
      "title": "Darkplane"
    },
    {
      "title": "About Darkplane",
      "href": "/docs/dash0/darkplane/overview",
      "lastUpdated": "2026-07-08T08:00:00.000Z"
    },
    {
      "title": "AI SDLC Insights",
      "children": [
        {
          "title": "About AI SDLC Insights",
          "href": "/docs/dash0/darkplane/insights",
          "lastUpdated": "2026-11-04T09:00:00.000Z"
        },
        {
          "title": "Set Up AI SDLC Insights",
          "href": "/docs/dash0/darkplane/insights/setup",
          "lastUpdated": "2026-11-04T09:00:00.000Z"
        },
        {
          "title": "Data Privacy & Redaction",
          "href": "/docs/dash0/darkplane/insights/data-privacy",
          "lastUpdated": "2026-10-06T13:00:00.000Z"
        },
        {
          "title": "Key Concepts",
          "href": "/docs/dash0/darkplane/insights/key-concepts",
          "lastUpdated": "2026-11-04T09:00:00.000Z"
        },
        {
          "title": "Explore AI SDLC Insights",
          "children": [
            {
              "title": "Read the Overview",
              "href": "/docs/dash0/darkplane/insights/overview",
              "lastUpdated": "2026-10-06T13:00:00.000Z"
            },
            {
              "title": "Track Cost",
              "href": "/docs/dash0/darkplane/insights/track-cost",
              "lastUpdated": "2026-11-04T09:00:00.000Z"
            },
            {
              "title": "Track Adoption",
              "href": "/docs/dash0/darkplane/insights/track-adoption",
              "lastUpdated": "2026-09-16T09:00:00.000Z"
            },
            {
              "title": "Measure Productivity",
              "href": "/docs/dash0/darkplane/insights/measure-productivity",
              "lastUpdated": "2026-09-16T09:00:00.000Z"
            },
            {
              "title": "Analyze Tools and Skills",
              "href": "/docs/dash0/darkplane/insights/analyze-tools-skills",
              "lastUpdated": "2026-09-16T09:00:00.000Z"
            },
            {
              "title": "Explore Sessions",
              "href": "/docs/dash0/darkplane/insights/explore-sessions",
              "lastUpdated": "2026-09-16T09:00:00.000Z"
            }
          ]
        },
        {
          "title": "Troubleshoot AI SDLC Insights",
          "href": "/docs/dash0/darkplane/insights/troubleshooting",
          "lastUpdated": "2026-09-16T09:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Span Attributes",
              "href": "/docs/dash0/darkplane/insights/span-attributes",
              "lastUpdated": "2026-11-04T09:00:00.000Z"
            },
            {
              "title": "Derived Metrics",
              "href": "/docs/dash0/darkplane/insights/derived-metrics",
              "lastUpdated": "2026-09-16T09:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Monitoring"
    },
    {
      "title": "Services",
      "children": [
        {
          "title": "About Service Monitoring",
          "href": "/docs/dash0/monitoring/services/about-services",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Use the Service Catalog",
          "href": "/docs/dash0/monitoring/services/use-service-catalog",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Use the Service Map",
          "href": "/docs/dash0/monitoring/services/use-service-map",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Built-in Service Metrics",
              "href": "/docs/dash0/monitoring/services/built-in-metrics",
              "lastUpdated": "2026-09-15T06:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Kubernetes",
      "children": [
        {
          "title": "About Kubernetes Monitoring",
          "href": "/docs/dash0/monitoring/kubernetes/about-kubernetes",
          "lastUpdated": "2026-07-31T17:00:00.000Z"
        },
        {
          "title": "Dash0 Operator for Kubernetes",
          "children": [
            {
              "title": "Overview",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/overview",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Installation",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/installation",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Configuration",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/configuration",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Automatic Workload Instrumentation",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/auto-instrumentation",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Metrics Collection and Prometheus Scraping",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/metrics-and-scraping",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Profiling",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/profiling",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Managing Dash0 Resources",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/managing-dash0-resources",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Agent0 Integration",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/agent0-integration",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Advanced Configuration",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/advanced-configuration",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "SignalControl Edge",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/signal-control-edge",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Synthetics Worker",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/synthetics-worker",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Platform-Specific Notes and Compatibility",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/platform-specific",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Troubleshooting",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/troubleshooting",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            },
            {
              "title": "Upgrading and Uninstallation",
              "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/upgrading",
              "lastUpdated": "2026-11-04T18:00:00.000Z"
            }
          ]
        },
        {
          "title": "Kubernetes Metrics",
          "href": "/docs/dash0/monitoring/kubernetes/kubernetes-metrics",
          "lastUpdated": "2026-04-20T05:00:00.000Z"
        }
      ]
    },
    {
      "title": "Resources",
      "children": [
        {
          "title": "About Resources",
          "href": "/docs/dash0/monitoring/resources/about-resources",
          "lastUpdated": "2026-05-07T15:00:00.000Z"
        },
        {
          "title": "Explore Resources",
          "href": "/docs/dash0/monitoring/resources/explore-resources",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Why Resource Equality?",
          "href": "/docs/dash0/monitoring/resources/resource-equality",
          "lastUpdated": "2026-05-07T15:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Overview",
              "href": "/docs/dash0/monitoring/resources/resource-equality-rules",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Kubernetes Resources",
              "href": "/docs/dash0/monitoring/resources/platforms/kubernetes",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "AWS Resources",
              "href": "/docs/dash0/monitoring/resources/platforms/aws",
              "lastUpdated": "2026-10-22T18:00:00.000Z"
            },
            {
              "title": "GCP Resources",
              "href": "/docs/dash0/monitoring/resources/platforms/gcp",
              "lastUpdated": "2026-08-06T10:00:00.000Z"
            },
            {
              "title": "Container and Host Resources",
              "href": "/docs/dash0/monitoring/resources/platforms/containers-and-hosts",
              "lastUpdated": "2026-05-07T15:00:00.000Z"
            },
            {
              "title": "Other Platform Resources",
              "href": "/docs/dash0/monitoring/resources/platforms/other-platforms",
              "lastUpdated": "2026-05-07T15:00:00.000Z"
            },
            {
              "title": "Storage & Query Behavior",
              "href": "/docs/dash0/monitoring/resources/resource-storage-query-behavior",
              "lastUpdated": "2026-05-07T15:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Websites",
      "children": [
        {
          "title": "About Website Monitoring",
          "href": "/docs/dash0/monitoring/websites/website-monitoring",
          "lastUpdated": "2026-11-02T12:00:00.000Z"
        },
        {
          "title": "Set Up the Web SDK",
          "href": "/docs/dash0/monitoring/websites/getting-started-website-monitoring",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Monitor Website Overview",
          "href": "/docs/dash0/monitoring/websites/monitor-website-overview",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Analyze Web Vitals",
          "href": "/docs/dash0/monitoring/websites/analyze-web-vitals",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Investigate Sessions",
          "children": [
            {
              "title": "About Investigating Sessions",
              "href": "/docs/dash0/monitoring/websites/investigate-sessions",
              "lastUpdated": "2026-10-28T08:00:00.000Z"
            },
            {
              "title": "View Session Details",
              "href": "/docs/dash0/monitoring/websites/view-session-details",
              "lastUpdated": "2026-10-28T08:00:00.000Z"
            },
            {
              "title": "View the Full Session",
              "href": "/docs/dash0/monitoring/websites/view-full-session",
              "lastUpdated": "2026-11-02T12:00:00.000Z"
            },
            {
              "title": "View Event Details",
              "href": "/docs/dash0/monitoring/websites/view-event-details",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "View the Full Trace",
              "href": "/docs/dash0/monitoring/websites/view-full-trace",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Filter Sessions and Data",
              "href": "/docs/dash0/monitoring/websites/filter-sessions-data",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Watch a Session Replay",
          "href": "/docs/dash0/monitoring/websites/watch-session-replay",
          "lastUpdated": "2026-11-02T12:00:00.000Z"
        },
        {
          "title": "Work with Source Maps",
          "children": [
            {
              "title": "Set Up Source Map Integration",
              "href": "/docs/dash0/monitoring/websites/set-up-source-map-integration",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Resolve Stack Traces with Source Maps",
              "href": "/docs/dash0/monitoring/websites/resolve-stack-traces-with-source-maps",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Correlate with Backend Traces",
          "href": "/docs/dash0/monitoring/websites/correlate-sessions-backend-traces",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Understand Web Vitals",
              "href": "/docs/dash0/monitoring/websites/understand-web-vitals",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Understand Sessions",
              "href": "/docs/dash0/monitoring/websites/understand-sessions",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Proxy the Ingestion Endpoint",
              "href": "/docs/dash0/monitoring/websites/proxying-the-ingestion-endpoint",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Understand Web SDK and Data Privacy",
              "href": "/docs/dash0/monitoring/websites/data-privacy",
              "lastUpdated": "2026-11-02T12:00:00.000Z"
            },
            {
              "title": "Troubleshoot Website Monitoring Issues",
              "href": "/docs/dash0/monitoring/websites/common-website-monitoring-issues",
              "lastUpdated": "2026-11-02T12:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Synthetics",
      "children": [
        {
          "title": "About Synthetic Monitoring",
          "href": "/docs/dash0/monitoring/synthetics/synthetic-monitoring",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Create Synthetic Checks",
          "children": [
            {
              "title": "About Creating Synthetic Checks",
              "href": "/docs/dash0/monitoring/synthetics/create-synthetic-checks",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Define Request Configuration",
              "href": "/docs/dash0/monitoring/synthetics/define-request-configuration",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Define Success Criteria",
              "href": "/docs/dash0/monitoring/synthetics/define-success-criteria",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Define Schedules & Retries",
              "href": "/docs/dash0/monitoring/synthetics/define-schedules-retries",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            }
          ]
        },
        {
          "title": "Run Checks from Private Locations",
          "href": "/docs/dash0/monitoring/synthetics/private-locations",
          "lastUpdated": "2026-10-07T04:00:00.000Z"
        },
        {
          "title": "Explore Synthetic Checks",
          "href": "/docs/dash0/monitoring/synthetics/explore-synthetic-checks",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Explore Run Details",
          "href": "/docs/dash0/monitoring/synthetics/explore-run-details",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Manage as Code",
          "children": [
            {
              "title": "About Managing as Code",
              "href": "/docs/dash0/monitoring/synthetics/about-synthetic-checks-as-code",
              "lastUpdated": "2026-07-19T09:00:00.000Z"
            },
            {
              "title": "Export Synthetic Checks",
              "href": "/docs/dash0/monitoring/synthetics/export-synthetic-checks",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Manage Synthetic Checks as Code",
              "href": "/docs/dash0/monitoring/synthetics/manage-synthetic-checks-as-code",
              "lastUpdated": "2026-07-19T09:00:00.000Z"
            }
          ]
        },
        {
          "title": "Understand Metrics About Synthetic Checks",
          "href": "/docs/dash0/monitoring/synthetics/understand-synthetic-metrics",
          "lastUpdated": "2026-09-28T16:00:00.000Z"
        }
      ]
    },
    {
      "title": "Alerting",
      "children": [
        {
          "title": "About Alerting",
          "href": "/docs/dash0/monitoring/alerting/alerting",
          "lastUpdated": "2026-09-15T13:00:00.000Z"
        },
        {
          "title": "Create Check Rules",
          "children": [
            {
              "title": "About Creating Check Rules",
              "href": "/docs/dash0/monitoring/alerting/create-check-rules",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Generate Check Rules with Agent0",
              "href": "/docs/dash0/monitoring/alerting/generate-alert-checks-with-agent0",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Create Check Rules from Charts",
              "href": "/docs/dash0/monitoring/alerting/create-check-rules-from-charts",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Create Check Rules from Scratch",
              "href": "/docs/dash0/monitoring/alerting/create-check-rules-from-scratch",
              "lastUpdated": "2026-10-27T11:00:00.000Z"
            }
          ]
        },
        {
          "title": "Investigate Failed Checks",
          "children": [
            {
              "title": "About Investigating Failed Checks",
              "href": "/docs/dash0/monitoring/alerting/investigate-failed-checks",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use the Failed Checks View",
              "href": "/docs/dash0/monitoring/alerting/use-failed-checks-view",
              "lastUpdated": "2026-10-26T14:00:00.000Z"
            },
            {
              "title": "Use the Failed Check Details View",
              "href": "/docs/dash0/monitoring/alerting/use-failed-check-details-view",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use the Failed Check Telemetry View",
              "href": "/docs/dash0/monitoring/alerting/use-failed-check-telemetry-view",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Silence Failed Checks",
              "href": "/docs/dash0/monitoring/alerting/silence-failed-checks",
              "lastUpdated": "2026-10-30T10:00:00.000Z"
            }
          ]
        },
        {
          "title": "Set Up Notification Channels",
          "children": [
            {
              "title": "About Notification Channels",
              "href": "/docs/dash0/monitoring/alerting/about-notifications",
              "lastUpdated": "2026-10-26T12:00:00.000Z"
            },
            {
              "title": "Set Up Notification Channels",
              "href": "/docs/dash0/monitoring/alerting/send-alert-check-notifications",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Monitor Notification Channel Delivery",
              "href": "/docs/dash0/monitoring/alerting/monitor-notification-channel-delivery",
              "lastUpdated": "2026-10-27T09:00:00.000Z"
            },
            {
              "title": "Route Check Rule Notifications",
              "href": "/docs/dash0/monitoring/alerting/route-alert-check-notifications",
              "lastUpdated": "2026-10-27T11:00:00.000Z"
            }
          ]
        },
        {
          "title": "Monitor SLOs",
          "children": [
            {
              "title": "About SLOs",
              "href": "/docs/dash0/monitoring/alerting/slos",
              "lastUpdated": "2026-10-26T20:00:00.000Z"
            },
            {
              "title": "Create SLOs",
              "href": "/docs/dash0/monitoring/alerting/create-slos",
              "lastUpdated": "2026-11-03T15:00:00.000Z"
            },
            {
              "title": "View and Analyze SLOs",
              "href": "/docs/dash0/monitoring/alerting/view-slos",
              "lastUpdated": "2026-10-26T20:00:00.000Z"
            },
            {
              "title": "Alert on SLOs",
              "href": "/docs/dash0/monitoring/alerting/alert-on-slos",
              "lastUpdated": "2026-11-04T14:30:00.000Z"
            }
          ]
        },
        {
          "title": "Manage as Code",
          "children": [
            {
              "title": "About Managing as Code",
              "href": "/docs/dash0/monitoring/alerting/about-check-rules-as-code",
              "lastUpdated": "2026-09-14T12:00:00.000Z"
            },
            {
              "title": "Export Check Rules",
              "href": "/docs/dash0/monitoring/alerting/export-check-rules",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Export Notification Channels",
              "href": "/docs/dash0/monitoring/alerting/export-notification-channels",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Manage Check Rules as Code",
              "href": "/docs/dash0/monitoring/alerting/manage-check-rules-as-code",
              "lastUpdated": "2026-08-25T11:00:00.000Z"
            },
            {
              "title": "Manage Notification Channels as Code",
              "href": "/docs/dash0/monitoring/alerting/manage-notification-channels-as-code",
              "lastUpdated": "2026-07-19T09:00:00.000Z"
            },
            {
              "title": "Manage SLOs as Code",
              "href": "/docs/dash0/monitoring/alerting/manage-slos-as-code",
              "lastUpdated": "2026-11-04T14:30:00.000Z"
            }
          ]
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Optimize Alert Messages with Templates",
              "href": "/docs/dash0/monitoring/alerting/create-contextual-alert-messages",
              "lastUpdated": "2026-10-27T11:00:00.000Z"
            },
            {
              "title": "Configure Meta Check Rules",
              "href": "/docs/dash0/monitoring/alerting/configure-meta-check-rules",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Understand the Alerting Model",
              "href": "/docs/dash0/monitoring/alerting/alerting-model",
              "lastUpdated": "2026-07-07T00:00:00.000Z"
            },
            {
              "title": "Check Rule Limits",
              "href": "/docs/dash0/monitoring/alerting/check-rule-limits",
              "lastUpdated": "2026-08-31T14:00:00.000Z"
            },
            {
              "title": "Use the SLO API",
              "href": "/docs/dash0/monitoring/alerting/slos-api",
              "lastUpdated": "2026-11-03T15:00:00.000Z"
            },
            {
              "title": "Troubleshoot Check Rule Issues",
              "href": "/docs/dash0/monitoring/alerting/troubleshooting-check-rules",
              "lastUpdated": "2026-10-26T14:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Infrastructure"
    },
    {
      "title": "AWS",
      "children": [
        {
          "title": "About AWS Monitoring",
          "href": "/docs/dash0/infrastructure/aws/about-aws",
          "lastUpdated": "2026-10-22T18:00:00.000Z"
        },
        {
          "title": "Set Up AWS Integration",
          "href": "/docs/dash0/infrastructure/aws/setup",
          "lastUpdated": "2026-10-22T18:00:00.000Z"
        },
        {
          "title": "AWS CloudWatch Metrics",
          "children": [
            {
              "title": "Collect AWS CloudWatch Metrics",
              "href": "/docs/dash0/infrastructure/aws/cloudwatch-metrics/collect-cloudwatch-metrics",
              "lastUpdated": "2026-10-28T07:00:00.000Z"
            },
            {
              "title": "Filter AWS Metrics by Resource Tags",
              "href": "/docs/dash0/infrastructure/aws/cloudwatch-metrics/filter-metrics-by-resource-tags",
              "lastUpdated": "2026-10-22T18:00:00.000Z"
            },
            {
              "title": "Use AWS Resource Tags in Dash0",
              "href": "/docs/dash0/infrastructure/aws/cloudwatch-metrics/use-resource-tags",
              "lastUpdated": "2026-10-28T07:00:00.000Z"
            },
            {
              "title": "Scraping vs. Metric Streams",
              "href": "/docs/dash0/infrastructure/aws/cloudwatch-metrics/scraping-vs-metric-streams",
              "lastUpdated": "2026-10-22T18:00:00.000Z"
            }
          ]
        },
        {
          "title": "AWS Lambda",
          "children": [
            {
              "title": "About AWS Lambda Monitoring",
              "href": "/docs/dash0/infrastructure/aws/aws-lambda/overview",
              "lastUpdated": "2026-09-11T09:00:00.000Z"
            },
            {
              "title": "Set Up AWS Lambda Auto Instrumentation",
              "href": "/docs/dash0/infrastructure/aws/aws-lambda/setup",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Trace Lambda Invocations",
              "href": "/docs/dash0/infrastructure/aws/aws-lambda/trace-lambda-functions",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Debug Timeouts and Errors",
              "href": "/docs/dash0/infrastructure/aws/aws-lambda/debug-timeouts-and-errors",
              "lastUpdated": "2026-07-13T11:00:00.000Z"
            },
            {
              "title": "Analyze Cold Starts",
              "href": "/docs/dash0/infrastructure/aws/aws-lambda/analyze-cold-starts",
              "lastUpdated": "2026-07-13T10:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Google Cloud",
      "children": [
        {
          "title": "About Google Cloud Monitoring",
          "href": "/docs/dash0/infrastructure/google-cloud/about-google-cloud",
          "lastUpdated": "2026-10-28T17:00:00.000Z"
        },
        {
          "title": "Set Up Google Cloud Integration",
          "href": "/docs/dash0/infrastructure/google-cloud/setup",
          "lastUpdated": "2026-10-28T18:00:00.000Z"
        },
        {
          "title": "Monitor Cloud Run Services",
          "href": "/docs/dash0/infrastructure/google-cloud/cloud-run",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Monitor Cloud Run Jobs",
          "href": "/docs/dash0/infrastructure/google-cloud/cloud-run-jobs",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Monitor Pub/Sub",
          "href": "/docs/dash0/infrastructure/google-cloud/pubsub",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Monitor Cloud Storage",
          "href": "/docs/dash0/infrastructure/google-cloud/cloud-storage",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Monitor Cloud SQL",
          "href": "/docs/dash0/infrastructure/google-cloud/cloud-sql",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        }
      ]
    },
    {
      "title": "Telemetry"
    },
    {
      "title": "Query Data",
      "children": [
        {
          "title": "Query Builder",
          "children": [
            {
              "title": "About the Query Builder",
              "href": "/docs/dash0/telemetry/query-data/query-builder/about-query-builder",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Analyze Service Performance",
              "href": "/docs/dash0/telemetry/query-data/query-builder/analyze-service-metrics",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Analyze Tracing Data",
              "href": "/docs/dash0/telemetry/query-data/query-builder/analyze-tracing-metrics",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Analyze Logs",
              "href": "/docs/dash0/telemetry/query-data/query-builder/analyze-logs",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Analyze All Metrics",
              "href": "/docs/dash0/telemetry/query-data/query-builder/analyze-all-metrics",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Analyze Web Events",
              "href": "/docs/dash0/telemetry/query-data/query-builder/analyze-web-events",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Write PromQL Queries",
              "href": "/docs/dash0/telemetry/query-data/query-builder/write-promql-queries",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "References",
              "children": [
                {
                  "title": "Examples: Service Queries",
                  "href": "/docs/dash0/telemetry/query-data/query-builder/references/examples-service-queries",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Examples: Tracing Queries",
                  "href": "/docs/dash0/telemetry/query-data/query-builder/references/examples-tracing-queries",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                },
                {
                  "title": "Examples: Log Queries",
                  "href": "/docs/dash0/telemetry/query-data/query-builder/references/examples-log-queries",
                  "lastUpdated": "2026-04-20T05:00:00.000Z"
                },
                {
                  "title": "Examples: Web Event Queries",
                  "href": "/docs/dash0/telemetry/query-data/query-builder/references/examples-web-event-queries",
                  "lastUpdated": "2026-07-08T08:00:00.000Z"
                }
              ]
            }
          ]
        },
        {
          "title": "SQL",
          "children": [
            {
              "title": "About Querying Data with SQL",
              "href": "/docs/dash0/telemetry/query-data/sql/about-sql",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Explore Your Schema",
              "href": "/docs/dash0/telemetry/query-data/sql/explore-your-schema",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Write SQL Queries",
              "href": "/docs/dash0/telemetry/query-data/sql/write-sql-queries",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Use Supported Functions",
              "href": "/docs/dash0/telemetry/query-data/sql/use-supported-functions",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Use Query Templates",
              "href": "/docs/dash0/telemetry/query-data/sql/use-query-templates",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Manage Saved Queries",
              "href": "/docs/dash0/telemetry/query-data/sql/manage-saved-queries",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Troubleshoot SQL Queries",
              "href": "/docs/dash0/telemetry/query-data/sql/troubleshoot-sql-queries",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Logging",
      "children": [
        {
          "title": "About Logging",
          "href": "/docs/dash0/telemetry/logging/about-logging",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Send Logs",
          "children": [
            {
              "title": "About Sending Logs",
              "href": "/docs/dash0/telemetry/logging/about-sending-logs",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Send Vercel Logs to Dash0",
              "href": "/docs/dash0/telemetry/logging/send-vercel-logs",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Send Pino Logs to Dash0",
              "href": "/docs/dash0/telemetry/logging/configure-pino",
              "lastUpdated": "2026-03-20T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Use AI in Logs",
          "children": [
            {
              "title": "About Using AI in Logs",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Filter by Log AI Attributes",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/filter-attributes",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Triage Log AI Attributes",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/triage-attributes",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Group Log AI Attributes",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/group-attributes",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "View Log AI Attributes",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/derived-attributes",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "View Log AI Severities",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/severity-indicator",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "View Log AI Pattern Details",
              "href": "/docs/dash0/telemetry/logging/use-ai-in-logs/pattern-hover",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Identify Log Severities",
          "href": "/docs/dash0/telemetry/logging/log-severities",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Browse and Filter Logs",
          "href": "/docs/dash0/telemetry/logging/log-table",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Analyze Logs in Groups",
          "href": "/docs/dash0/telemetry/logging/groups",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Identify Patterns in Logs",
          "href": "/docs/dash0/telemetry/logging/patterns",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Analyze Logs with Triage",
          "href": "/docs/dash0/telemetry/logging/triage",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Inspect Log Details",
          "href": "/docs/dash0/telemetry/logging/log-sidebar",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Explore Related Logs",
          "href": "/docs/dash0/telemetry/logging/related-logs",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Organize and Save Log Views",
          "href": "/docs/dash0/telemetry/logging/views",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Understand Log Events",
          "href": "/docs/dash0/telemetry/logging/understand-log-events",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "How Log AI Processes Logs",
              "href": "/docs/dash0/telemetry/logging/log-ai-processing",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "How Dash0 Processes JSON logs",
              "href": "/docs/dash0/telemetry/logging/json-log-processing",
              "lastUpdated": "2026-03-27T16:00:00.000Z"
            },
            {
              "title": "How Dash0 Processes NGINX Logs",
              "href": "/docs/dash0/telemetry/logging/nginx-log-processing",
              "lastUpdated": "2026-03-27T16:00:00.000Z"
            },
            {
              "title": "How Dash0 Processes Kubernetes Object Logs",
              "href": "/docs/dash0/telemetry/logging/k8s-object-log-processing",
              "lastUpdated": "2026-05-27T13:00:00.000Z"
            },
            {
              "title": "Optimize Log Query Performance",
              "href": "/docs/dash0/telemetry/logging/optimize-log-query-performance",
              "lastUpdated": "2026-04-20T12:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Metrics",
      "children": [
        {
          "title": "About Metrics",
          "href": "/docs/dash0/telemetry/metrics/about-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Identify High-Cardinality Metrics",
          "href": "/docs/dash0/telemetry/metrics/identify-high-cardinality-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Browse and Filter Metrics",
          "href": "/docs/dash0/telemetry/metrics/browse-and-filter-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Inspect Metric Details",
          "href": "/docs/dash0/telemetry/metrics/inspect-metric-details",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Query Metrics in the Query Builder",
          "href": "/docs/dash0/telemetry/metrics/query-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Understand Synthetic Metrics",
          "href": "/docs/dash0/telemetry/metrics/understand-synthetic-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "References",
          "children": [
            {
              "title": "Understand OpenTelemetry Metric Names and Labels",
              "href": "/docs/dash0/telemetry/metrics/understand-otel-metric-names",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Write Effective PromQL Queries",
              "href": "/docs/dash0/telemetry/metrics/write-effective-promql-queries",
              "lastUpdated": "2026-08-25T11:00:00.000Z"
            },
            {
              "title": "Optimize PromQL Query Performance",
              "href": "/docs/dash0/telemetry/metrics/optimize-promql-query-performance",
              "lastUpdated": "2026-09-07T12:00:00.000Z"
            },
            {
              "title": "Common Metric Query Issues",
              "href": "/docs/dash0/telemetry/metrics/common-metric-query-issues",
              "lastUpdated": "2026-10-11T12:00:00.000Z"
            },
            {
              "title": "Recording Rule Limits",
              "href": "/docs/dash0/telemetry/metrics/recording-rule-limits",
              "lastUpdated": "2026-07-24T08:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Tracing",
      "children": [
        {
          "title": "About Tracing",
          "href": "/docs/dash0/telemetry/tracing/about-tracing",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "About GenAI Spans",
          "href": "/docs/dash0/telemetry/tracing/about-gen-ai-spans",
          "lastUpdated": "2026-10-08T13:00:00.000Z"
        },
        {
          "title": "Find Performance and Error Outliers",
          "href": "/docs/dash0/telemetry/tracing/outliers-map",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Monitor Requests, Errors, and Duration",
          "href": "/docs/dash0/telemetry/tracing/red",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Browse and Filter Spans",
          "href": "/docs/dash0/telemetry/tracing/span-table",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Analyze Spans in Groups",
          "href": "/docs/dash0/telemetry/tracing/groups",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Analyze Spans with Triage",
          "href": "/docs/dash0/telemetry/tracing/triage",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Inspect Span Details",
          "href": "/docs/dash0/telemetry/tracing/span-sidebar",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Visualize the Full Trace",
          "href": "/docs/dash0/telemetry/tracing/view",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Organize and Save Span Views",
          "href": "/docs/dash0/telemetry/tracing/view-explorer",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Understand Span Events",
          "href": "/docs/dash0/telemetry/tracing/span-events",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Convert Span Events to Log Records",
          "href": "/docs/dash0/telemetry/tracing/span-events-to-logs",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        }
      ]
    },
    {
      "title": "Web Events",
      "children": [
        {
          "title": "About Web Events",
          "href": "/docs/dash0/telemetry/web-events/about-web-events",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Explore All Web Events",
          "href": "/docs/dash0/telemetry/web-events/explore-all-web-events",
          "lastUpdated": "2026-11-02T12:00:00.000Z"
        },
        {
          "title": "Analyze Page Views",
          "href": "/docs/dash0/telemetry/web-events/analyze-page-views",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Monitor JavaScript Errors",
          "href": "/docs/dash0/telemetry/web-events/monitor-javascript-errors",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Track HTTP Requests",
          "href": "/docs/dash0/telemetry/web-events/track-http-requests",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Use Custom Events",
          "href": "/docs/dash0/telemetry/web-events/use-custom-events",
          "lastUpdated": "2026-10-28T08:00:00.000Z"
        },
        {
          "title": "Understand Web Event Types",
          "href": "/docs/dash0/telemetry/web-events/understand-web-event-types",
          "lastUpdated": "2026-11-02T12:00:00.000Z"
        },
        {
          "title": "Filter and Group Web Events",
          "href": "/docs/dash0/telemetry/web-events/filter-and-group-web-events",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        }
      ]
    },
    {
      "title": "SignalControl",
      "children": [
        {
          "title": "About SignalControl",
          "href": "/docs/dash0/telemetry/signal-control/about-signal-control",
          "lastUpdated": "2026-10-23T11:00:00.000Z"
        },
        {
          "title": "Filter Out Spam",
          "href": "/docs/dash0/telemetry/signal-control/filter-out-spam",
          "lastUpdated": "2026-09-06T23:00:00.000Z"
        },
        {
          "title": "Convert Signals to Metrics",
          "href": "/docs/dash0/telemetry/signal-control/convert-signals-to-metrics",
          "lastUpdated": "2026-10-23T12:00:00.000Z"
        },
        {
          "title": "Sample Traces",
          "href": "/docs/dash0/telemetry/signal-control/sample-traces",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Aggregate Time Series",
          "href": "/docs/dash0/telemetry/signal-control/aggregate-time-series",
          "lastUpdated": "2026-09-06T23:00:00.000Z"
        },
        {
          "title": "SignalControl Edge",
          "children": [
            {
              "title": "About SignalControl Edge",
              "href": "/docs/dash0/telemetry/signal-control/edge/about-signalcontrol-edge",
              "lastUpdated": "2026-10-23T11:00:00.000Z"
            },
            {
              "title": "Set Up Without Kubernetes",
              "href": "/docs/dash0/telemetry/signal-control/edge/setup-without-kubernetes",
              "lastUpdated": "2026-10-23T11:00:00.000Z"
            },
            {
              "title": "Deploy the Edge Proxy",
              "href": "/docs/dash0/telemetry/signal-control/edge/edge-proxy",
              "lastUpdated": "2026-09-07T18:00:00.000Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Data Privacy",
      "children": [
        {
          "title": "Redact Cardholder Data",
          "href": "/docs/dash0/telemetry/data-privacy/redact-cardholder-data",
          "lastUpdated": "2026-10-02T10:00:00.000Z"
        }
      ]
    },
    {
      "title": "OpenTelemetry"
    },
    {
      "title": "Dash0 Distributions",
      "children": [
        {
          "title": "Python",
          "children": [
            {
              "title": "About the Dash0 OpenTelemetry Python Distribution",
              "href": "/docs/dash0/opentelemetry/distributions/python/overview",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "Getting Started",
              "href": "/docs/dash0/opentelemetry/distributions/python/getting-started",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "Configuration",
              "href": "/docs/dash0/opentelemetry/distributions/python/configuration",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "Auto-instrumentation",
              "href": "/docs/dash0/opentelemetry/distributions/python/auto-instrumentation",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "Resource Detection",
              "href": "/docs/dash0/opentelemetry/distributions/python/resource-detection",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "Kubernetes Injection",
              "href": "/docs/dash0/opentelemetry/distributions/python/kubernetes-injection",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            },
            {
              "title": "OTLP Exporters",
              "href": "/docs/dash0/opentelemetry/distributions/python/exporters",
              "lastUpdated": "2026-10-24T00:17:44.297Z"
            }
          ]
        },
        {
          "title": "Ruby",
          "children": [
            {
              "title": "About the Dash0 OpenTelemetry Ruby Distribution",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/overview",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            },
            {
              "title": "Getting Started",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/getting-started",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            },
            {
              "title": "Configuration",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/configuration",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            },
            {
              "title": "Auto-instrumentation",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/auto-instrumentation",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            },
            {
              "title": "Resource Detection",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/resource-detection",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            },
            {
              "title": "Kubernetes Injection",
              "href": "/docs/dash0/opentelemetry/distributions/ruby/kubernetes-injection",
              "lastUpdated": "2026-08-07T07:55:03.588Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Dash0 Semantic Conventions",
      "children": [
        {
          "title": "Overview",
          "href": "/docs/dash0/opentelemetry/semconvs/overview",
          "lastUpdated": "2026-09-01T11:01:17.521Z"
        },
        {
          "title": "Attributes",
          "children": [
            {
              "title": "Attribute Registry",
              "href": "/docs/dash0/opentelemetry/semconvs/attributes/overview",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Log Attributes",
              "href": "/docs/dash0/opentelemetry/semconvs/attributes/log",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Metric Attributes",
              "href": "/docs/dash0/opentelemetry/semconvs/attributes/metric",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Span Attributes",
              "href": "/docs/dash0/opentelemetry/semconvs/attributes/span",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Web Event Attributes",
              "href": "/docs/dash0/opentelemetry/semconvs/attributes/web-event",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            }
          ]
        },
        {
          "title": "Metrics",
          "children": [
            {
              "title": "Metric Registry",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/overview",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Automation Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/automations",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Check Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/check",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Gen AI Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/gen-ai",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Issue Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/issue",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Log Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/logs",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Metric Datapoint Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/metrics",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Operator Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/operator",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Resource Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/resources",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "SLO Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/slo",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Span Event Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/span",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Spam Filter Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/spam-filters",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Span Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/spans",
              "lastUpdated": "2026-10-10T16:00:00.000Z"
            },
            {
              "title": "Synthetic Check Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/synthetic-check",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Web Metrics",
              "href": "/docs/dash0/opentelemetry/semconvs/metrics/web",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            }
          ]
        },
        {
          "title": "Events",
          "children": [
            {
              "title": "Event Registry",
              "href": "/docs/dash0/opentelemetry/semconvs/events/overview",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            },
            {
              "title": "Deployment Events",
              "href": "/docs/dash0/opentelemetry/semconvs/events/deployment",
              "lastUpdated": "2026-09-01T11:01:17.521Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Dash0 Operator for Kubernetes",
      "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/overview",
      "lastUpdated": "2026-11-04T18:00:00.000Z"
    },
    {
      "title": "Miscellaneous"
    },
    {
      "title": "Infrastructure as Code",
      "children": [
        {
          "title": "About Managing as Code",
          "href": "/docs/dash0/miscellaneous/manage-as-code/about-managing-as-code",
          "lastUpdated": "2026-09-15T11:00:00.000Z"
        },
        {
          "title": "Manage Check Rules as Code",
          "href": "/docs/dash0/monitoring/alerting/manage-check-rules-as-code",
          "lastUpdated": "2026-08-25T11:00:00.000Z"
        },
        {
          "title": "Manage CI/CD Observability as Code",
          "href": "/docs/dash0/miscellaneous/manage-as-code/manage-cicd-observability-as-code",
          "lastUpdated": "2026-07-27T15:36:18.739Z"
        },
        {
          "title": "Manage Dashboards as Code",
          "href": "/docs/dash0/dashboards/manage-dashboards-as-code",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Manage Notification Channels as Code",
          "href": "/docs/dash0/monitoring/alerting/manage-notification-channels-as-code",
          "lastUpdated": "2026-07-19T09:00:00.000Z"
        },
        {
          "title": "Manage SLOs as Code",
          "href": "/docs/dash0/monitoring/alerting/manage-slos-as-code",
          "lastUpdated": "2026-11-04T14:30:00.000Z"
        },
        {
          "title": "Manage Spam Filters as Code",
          "href": "/docs/dash0/cost-control/manage-spam-filters-as-code",
          "lastUpdated": "2026-08-09T18:00:00.000Z"
        },
        {
          "title": "Manage Synthetic Checks as Code",
          "href": "/docs/dash0/monitoring/synthetics/manage-synthetic-checks-as-code",
          "lastUpdated": "2026-07-19T09:00:00.000Z"
        },
        {
          "title": "Manage Teams as Code",
          "href": "/docs/dash0/miscellaneous/manage-as-code/manage-teams-as-code",
          "lastUpdated": "2026-07-27T14:00:00.000Z"
        },
        {
          "title": "Manage Views as Code",
          "href": "/docs/dash0/miscellaneous/views/manage-views-as-code",
          "lastUpdated": "2026-07-19T09:00:00.000Z"
        }
      ]
    },
    {
      "title": "Settings",
      "children": [
        {
          "title": "About Settings",
          "href": "/docs/dash0/miscellaneous/settings",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "AI",
          "href": "/docs/dash0/miscellaneous/settings/ai",
          "lastUpdated": "2026-10-29T15:00:00.000Z"
        },
        {
          "title": "Audit Logs",
          "href": "/docs/dash0/miscellaneous/settings/audit-logs",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Auth Tokens",
          "href": "/docs/dash0/miscellaneous/glossary/auth-tokens",
          "lastUpdated": "2026-10-20T12:00:00.000Z"
        },
        {
          "title": "Billing & Plans",
          "href": "/docs/dash0/miscellaneous/settings/billing",
          "lastUpdated": "2026-10-22T10:15:35.000Z"
        },
        {
          "title": "Datasets",
          "href": "/docs/dash0/miscellaneous/glossary/datasets",
          "lastUpdated": "2026-10-21T08:00:00.000Z"
        },
        {
          "title": "Endpoints",
          "href": "/docs/dash0/miscellaneous/glossary/endpoints",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "General",
          "href": "/docs/dash0/miscellaneous/settings/general",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Integrations",
          "children": [
            {
              "title": "About Integrations",
              "href": "/docs/dash0/miscellaneous/settings/integrations",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "GitHub",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/github/setup",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "GitLab",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/gitlab/setup",
              "lastUpdated": "2026-08-26T07:00:00.000Z"
            },
            {
              "title": "Google Cloud",
              "href": "/docs/dash0/infrastructure/google-cloud/setup",
              "lastUpdated": "2026-10-28T18:00:00.000Z"
            },
            {
              "title": "Linear",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/linear/setup",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "MCP",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/generic-mcp/setup",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Slack",
              "href": "/docs/dash0/ai/agent0/overview/integrate-with-agent0/slack/setup",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            },
            {
              "title": "Source Maps",
              "href": "/docs/dash0/monitoring/websites/set-up-source-map-integration",
              "lastUpdated": "2026-07-08T08:00:00.000Z"
            }
          ]
        },
        {
          "title": "Members",
          "href": "/docs/dash0/miscellaneous/glossary/access-control",
          "lastUpdated": "2026-10-12T11:00:00.000Z"
        },
        {
          "title": "Notification Channels",
          "href": "/docs/dash0/monitoring/alerting/about-notifications",
          "lastUpdated": "2026-10-26T12:00:00.000Z"
        },
        {
          "title": "OAuth 2.0",
          "href": "/docs/dash0/miscellaneous/settings/oauth2",
          "lastUpdated": "2026-09-05T14:00:00.000Z"
        },
        {
          "title": "Teams",
          "href": "/docs/dash0/miscellaneous/glossary/teams",
          "lastUpdated": "2026-11-03T13:00:00.000Z"
        },
        {
          "title": "User Authentication",
          "href": "/docs/dash0/miscellaneous/settings/user-authentication",
          "lastUpdated": "2026-11-03T13:00:00.000Z"
        }
      ]
    },
    {
      "title": "Views",
      "children": [
        {
          "title": "About Views",
          "href": "/docs/dash0/miscellaneous/views/about-views",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Export Views",
          "href": "/docs/dash0/miscellaneous/views/export-views",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Manage Views as Code",
          "href": "/docs/dash0/miscellaneous/views/manage-views-as-code",
          "lastUpdated": "2026-07-19T09:00:00.000Z"
        }
      ]
    },
    {
      "title": "Tooling",
      "children": [
        {
          "title": "Dash0 Operator for Kubernetes",
          "href": "/docs/dash0/monitoring/kubernetes/dash0-operator/overview",
          "lastUpdated": "2026-11-04T18:00:00.000Z"
        },
        {
          "title": "Dash0 GitHub Action for CI/CD",
          "href": "/docs/dash0/miscellaneous/manage-as-code/manage-cicd-observability-as-code",
          "lastUpdated": "2026-07-27T15:36:18.739Z"
        },
        {
          "title": "Dash0 CLI",
          "children": [
            {
              "title": "About the Dash0 CLI",
              "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/about",
              "lastUpdated": "2026-10-22T16:16:05.083Z"
            },
            {
              "title": "Installation",
              "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/installation",
              "lastUpdated": "2026-10-22T16:16:05.083Z"
            },
            {
              "title": "Quickstart",
              "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/quickstart",
              "lastUpdated": "2026-10-22T16:16:05.083Z"
            },
            {
              "title": "Command Reference",
              "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/commands",
              "lastUpdated": "2026-10-22T16:16:05.083Z"
            },
            {
              "title": "GitHub Actions",
              "children": [
                {
                  "title": "About GitHub Actions",
                  "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/github-actions/about",
                  "lastUpdated": "2026-10-22T16:16:05.083Z"
                },
                {
                  "title": "Setup Dash0 CLI",
                  "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/github-actions/setup",
                  "lastUpdated": "2026-10-22T16:16:05.083Z"
                },
                {
                  "title": "Send Log Event",
                  "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/github-actions/send-log-event",
                  "lastUpdated": "2026-10-22T16:16:05.083Z"
                },
                {
                  "title": "Sync Dash0 Assets",
                  "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/github-actions/sync-assets",
                  "lastUpdated": "2026-10-22T16:16:05.083Z"
                }
              ]
            },
            {
              "title": "Homebrew Tap Migration (June 2026)",
              "href": "/docs/dash0/miscellaneous/tooling/dash0-cli/brew-tap-migration-2026-06",
              "lastUpdated": "2026-10-22T16:16:05.083Z"
            }
          ]
        },
        {
          "title": "Dash0 Terraform Provider",
          "children": [
            {
              "title": "About the Dash0 Terraform Provider",
              "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/about",
              "lastUpdated": "2026-11-02T09:59:35.825Z"
            },
            {
              "title": "Quickstart",
              "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/quickstart",
              "lastUpdated": "2026-11-02T09:59:35.825Z"
            },
            {
              "title": "Configuration",
              "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/configuration",
              "lastUpdated": "2026-11-02T09:59:35.825Z"
            },
            {
              "title": "Guides",
              "children": [
                {
                  "title": "Import existing Dash0 assets into Terraform",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/guides/import-existing-assets",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "AWS integration via CloudFormation",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/guides/aws-cloudformation-integration",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                }
              ]
            },
            {
              "title": "Actions",
              "children": [
                {
                  "title": "dash0_deployment_event",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/actions/deployment-event",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_log_event",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/actions/log-event",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                }
              ]
            },
            {
              "title": "Resources",
              "children": [
                {
                  "title": "dash0_auth_token",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/auth-token",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_aws_metric_scrape_config",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/aws-metric-scrape-config",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_check_rule",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/check-rule",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_dashboard",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/dashboard",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_dataset",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/dataset",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_notification_channel",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/notification-channel",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_recording_rule",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/recording-rule",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_sampling_rule",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/sampling-rule",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_slo",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/slo",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_spam_filter",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/spam-filter",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_synthetic_check",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/synthetic-check",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_team",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/team",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_time_series_aggregation",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/time-series-aggregation",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                },
                {
                  "title": "dash0_view",
                  "href": "/docs/dash0/miscellaneous/tooling/terraform-provider-dash0/resources/view",
                  "lastUpdated": "2026-11-02T09:59:35.825Z"
                }
              ]
            }
          ]
        },
        {
          "title": "Dash0 Web SDK",
          "children": [
            {
              "title": "About the Dash0 Web SDK",
              "href": "/docs/dash0/miscellaneous/tooling/web-sdk/overview",
              "lastUpdated": "2026-10-26T11:21:43.337Z"
            },
            {
              "title": "Installation",
              "href": "/docs/dash0/miscellaneous/tooling/web-sdk/installation",
              "lastUpdated": "2026-10-26T11:21:43.337Z"
            },
            {
              "title": "Setup",
              "href": "/docs/dash0/miscellaneous/tooling/web-sdk/setup",
              "lastUpdated": "2026-10-26T11:21:43.337Z"
            },
            {
              "title": "Configuration",
              "href": "/docs/dash0/miscellaneous/tooling/web-sdk/configuration",
              "lastUpdated": "2026-10-26T11:21:43.337Z"
            },
            {
              "title": "API Reference",
              "href": "/docs/dash0/miscellaneous/tooling/web-sdk/api",
              "lastUpdated": "2026-10-26T11:21:43.337Z"
            }
          ]
        }
      ]
    },
    {
      "title": "Troubleshooting",
      "href": "/docs/dash0/miscellaneous/troubleshooting",
      "lastUpdated": "2026-07-08T08:00:00.000Z"
    },
    {
      "title": "Glossary",
      "children": [
        {
          "title": "About the Glossary",
          "href": "/docs/dash0/miscellaneous/glossary/overview",
          "lastUpdated": "2026-10-07T18:00:00.000Z"
        },
        {
          "title": "Access Control",
          "href": "/docs/dash0/miscellaneous/glossary/access-control",
          "lastUpdated": "2026-10-12T11:00:00.000Z"
        },
        {
          "title": "Adaptive Sampling",
          "href": "/docs/dash0/miscellaneous/glossary/adaptive-sampling",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Auth Tokens",
          "href": "/docs/dash0/miscellaneous/glossary/auth-tokens",
          "lastUpdated": "2026-10-20T12:00:00.000Z"
        },
        {
          "title": "Command Menu",
          "href": "/docs/dash0/miscellaneous/glossary/command-menu",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Cost Control",
          "href": "/docs/dash0/cost-control/overview",
          "lastUpdated": "2026-10-22T10:15:35.000Z"
        },
        {
          "title": "Dash0 API",
          "href": "/docs/dash0/miscellaneous/glossary/dash0-api",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Datasets",
          "href": "/docs/dash0/miscellaneous/glossary/datasets",
          "lastUpdated": "2026-10-21T08:00:00.000Z"
        },
        {
          "title": "Deeplink URLs",
          "href": "/docs/dash0/miscellaneous/glossary/deeplink-urls",
          "lastUpdated": "2026-07-23T08:00:00.000Z"
        },
        {
          "title": "Endpoints",
          "href": "/docs/dash0/miscellaneous/glossary/endpoints",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Evals",
          "href": "/docs/dash0/miscellaneous/glossary/evals",
          "lastUpdated": "2026-10-07T18:00:00.000Z"
        },
        {
          "title": "Filtering",
          "href": "/docs/dash0/miscellaneous/glossary/filtering",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Infrastructure as Code",
          "href": "/docs/dash0/miscellaneous/glossary/infrastructure-as-code",
          "lastUpdated": "2026-09-14T12:00:00.000Z"
        },
        {
          "title": "Operations",
          "href": "/docs/dash0/miscellaneous/glossary/operation-names",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Organizations",
          "href": "/docs/dash0/miscellaneous/glossary/organizations",
          "lastUpdated": "2026-09-29T15:00:00.000Z"
        },
        {
          "title": "RED Metrics",
          "href": "/docs/dash0/miscellaneous/glossary/red-metrics",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Resource Equality",
          "href": "/docs/dash0/miscellaneous/glossary/resource-equality",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Resource Fragmentation",
          "href": "/docs/dash0/miscellaneous/glossary/resource-fragmentation",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Semantic Conventions",
          "href": "/docs/dash0/miscellaneous/glossary/semantic-conventions",
          "lastUpdated": "2026-08-07T10:00:00.000Z"
        },
        {
          "title": "Semantic Convention Upgrades",
          "href": "/docs/dash0/miscellaneous/glossary/semantic-convention-upgrades",
          "lastUpdated": "2026-07-08T08:00:00.000Z"
        },
        {
          "title": "Synthetic Metrics",
          "href": "/docs/dash0/miscellaneous/glossary/synthetic-metrics",
          "lastUpdated": "2026-09-05T14:00:00.000Z"
        },
        {
          "title": "Teams",
          "href": "/docs/dash0/miscellaneous/glossary/teams",
          "lastUpdated": "2026-11-03T13:00:00.000Z"
        },
        {
          "title": "Time Picker",
          "href": "/docs/dash0/miscellaneous/glossary/time-picker",
          "lastUpdated": "2026-10-11T12:00:00.000Z"
        },
        {
          "title": "Views",
          "href": "/docs/dash0/miscellaneous/glossary/views",
          "lastUpdated": "2026-10-11T10:00:00.000Z"
        }
      ]
    },
    {
      "title": "FAQ",
      "href": "/docs/dash0/miscellaneous/faq",
      "lastUpdated": "2026-09-04T08:00:00.000Z"
    }
  ]
};

export const sidebarNavigation: SidebarNavigationStructure = navigationBySection["dash0"] ?? [];
